import { useEffect, useState } from 'react'
import { AlertCircle } from 'lucide-react'
import { useCoachStore } from '@/stores/coachStore'
import { useLibraryStore } from '@/stores/libraryStore'
import { ExerciseLibraryView } from '@/components/library/ExerciseLibraryView'
import { EquipmentLibraryView } from '@/components/library/EquipmentLibraryView'

export function LibraryPage() {
  const { setCurrentPage } = useCoachStore()
  const { activeTab, setActiveTab, loadLibraryData } = useLibraryStore()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setCurrentPage('library')
    loadLibraryData().catch((err) => {
      console.error('Failed to load library data:', err)
      setError('Failed to load library data. Some features may not work properly.')
    })
  }, [setCurrentPage, loadLibraryData])


  return (
    <div className="space-y-6">
      {/* Error Banner */}
      {error && (
        <div className="bg-warning-50 border border-warning-200 rounded-lg p-4">
          <div className="flex">
            <AlertCircle className="w-5 h-5 text-warning-600 mt-0.5" />
            <div className="ml-3">
              <p className="text-sm text-warning-800">{error}</p>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="coach-header">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Library</h1>
          <p className="text-gray-600">
            Manage your exercise and equipment catalog
          </p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <div className="flex space-x-8">
          <button
            onClick={() => setActiveTab('exercises')}
            className={`py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'exercises'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Exercise Library
          </button>
          <button
            onClick={() => setActiveTab('equipment')}
            className={`py-2 px-1 border-b-2 font-medium text-sm ${
              activeTab === 'equipment'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Equipment Catalog
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'exercises' && <ExerciseLibraryView />}
        {activeTab === 'equipment' && <EquipmentLibraryView />}
      </div>
    </div>
  )
}